import React from 'react';
import { splitOnPlaceholdersAndLinks } from '../../utils/invitationEmail';

/**
 * Text with unresolved placeholders highlighted and http(s) links rendered
 * as clickable anchors.
 *
 * Shared between the two invitation dialogs (`SendAssessmentDialog` and
 * `AssessmentModal`) so both mark placeholders and link the questionnaire
 * URL the same way, rather than each carrying its own copy of this rendering.
 */
export function withMarkedPlaceholders(text) {
  return splitOnPlaceholdersAndLinks(text).map((part, i) => {
    if (part.placeholder) {
      return (
        <mark key={i} className="bg-amber-200 dark:bg-amber-500/40 text-inherit rounded px-0.5">
          {part.text}
        </mark>
      );
    }
    if (part.link) {
      return (
        <a
          key={i}
          href={part.text}
          target="_blank"
          rel="noopener noreferrer"
          className="break-all text-blue-600 dark:text-blue-400 hover:underline"
        >
          {part.text}
        </a>
      );
    }
    return <React.Fragment key={i}>{part.text}</React.Fragment>;
  });
}
